export const chooseAddons = {
	title: {
		sv: "Extra kort och krediter",
	},
	description: {
		sv: "Lägg till vad du behöver utöver det som ingår i paketet du valde. Extra kort kopplas till samma konto.",
	},
	addonPrice: {
		sv: "{0} kr",
	},
	addonPricePerMonth: {
		sv: "{0} kr/månad",
	},
	addonPriceBillingPeriod: {
		sv: "/mån",
	},
	creditAccountPrice: {
		sv: "Från {0} kr/mån",
	},
	amountLabel: {
		sv: "Antal {0}",
	},
	addAddonLabel: {
		sv: "Lägg till {0}",
	},
	addAddonText: {
		sv: "Lägg till",
	},
	extraCards: {
		sv: "extra kort",
	},
	removeAddonLabel: {
		sv: "Ta bort {0}",
	},
	creditDialog: {
		title: {
			sv: "Du kvalificerar för kredit",
		},
		body: {
			sv: "Utifrån vår första bedömning har du möjlighet att lägga till kreditkort eller kontokredit – nu eller senare. Kontokredit kan hjälpa dig att jämna ut företagets kassaflöde.",
		},
		continueButton: {
			sv: "Kanske senare",
		},
		cancelButton: {
			sv: "Lägg till kreditprodukter",
		},
	},
};
